module.exports = __webpack_public_path__ + "static/img/emoji_149.0aa6d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji/emoji_149.png
// module id = 6k+C
// module chunks = 6